var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { useEffect, useRef } from 'react';

import { Bars3Icon } from '@heroicons/react/20/solid';


import { hoverSortable } from "./SortFunction";


import { withDnD } from "../../componentWrappers";





















/* eslint-disable comma-spacing */
const hasValidContext = (dropContext) => dropContext !== undefined;

/* eslint-disable comma-spacing */
const isNotAutoContained = (
currentItem,
draggedResult,
dropParent) => {var _draggedResult$item$p;return (

    (draggedResult.item.container !== currentItem.container ||
    dropParent === undefined ||
    (dropParent === null || dropParent === void 0 ? void 0 : dropParent.dndId) !== ((_draggedResult$item$p = draggedResult.item.parent) === null || _draggedResult$item$p === void 0 ? void 0 : _draggedResult$item$p.dndId) ||
    draggedResult.item.container === undefined) && (
    dropParent === undefined || draggedResult.item.dndId !== dropParent.dndId));};

/* eslint-disable comma-spacing */
const hasNoItems = (currentItem) =>
currentItem.value.items === undefined || currentItem.value.items.length === 0;

const getOpacityLevel = (isDragging) => isDragging ? 0 : 1;

const getIconHandleClass = (condition) => condition ? 'cursor-move' : '';

/* eslint-disable comma-spacing */
const elementTestId = (
item,
context,
container,
index) =>

`${
(item.parent ? `group_${context.getDisplayName(item.parent)}` : '') || container || 'available'
}-draggable-item-${index}`;

/* eslint-disable comma-spacing */
// eslint-disable-next-line max-statements
const DraggableItemComponent = ({
  item,
  useDrag = () => {},
  useDrop = () => {},
  iconHandle = false,
  index,
  children,
  context,
  className,
  omitIcon = false,
  wrapperType = 'li',
  container,
  previewRef
}) => {
  const ref = useRef(null);
  const [, drop] = useDrop({
    accept: context.type,
    item: { item: _objectSpread(_objectSpread({}, item), {}, { container }), container, index },
    hover: hoverSortable(ref, _objectSpread(_objectSpread({}, item), {}, { container }), index, context.setDragging, context.sort)
  });
  const [{ isDragging, handlerId }, drag, preview] = useDrag({
    type: context.type,
    item: { item: _objectSpread(_objectSpread({}, item), {}, { container }), index },
    end: (draggedResult, monitor) => {
      context.setDragging(false);
      const { context: dropContext, parent: dropParent } =
      monitor.getDropResult() || {};

      const draggedItem = item.dndId === draggedResult.item.dndId ? draggedResult.item : item;
      if (
      hasValidContext(dropContext) &&
      isNotAutoContained(draggedItem, draggedResult, dropParent) &&
      hasNoItems(item) &&
      !draggedResult.item.fixed)
      {
        context.addItem(draggedResult.item, dropParent);
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
      handlerId: monitor.getHandlerId()
    })
  });

  const previewReference = previewRef || ref;

  useEffect(() => {
    preview(previewReference);
  }, [preview, previewReference]);

  const opacity = getOpacityLevel(isDragging);

  if (previewReference && previewReference.current) {
    // eslint-disable-next-line no-param-reassign
    previewReference.current.style.opacity = getOpacityLevel(isDragging).toString();
  }

  drag(drop(ref));
  drag(drop(previewReference));

  const TagName = wrapperType;

  return /*#__PURE__*/(
    React.createElement(TagName, {
      className: `${
      className ||
      'flex flex-row pl-3 mt-2 mb-2 border border-gray-200 border-solid min-w-full items-center'
      }  ${getIconHandleClass(iconHandle)} `,
      ref: ref,
      "data-testid": elementTestId(item, context, container, index),
      style: { opacity },
      "data-handler-id": handlerId,
      key: TagName + item.dndId },

    !omitIcon && wrapperType === 'li' && /*#__PURE__*/
    _jsx(Bars3Icon, { className: `w-4 text-gray-400 ${getIconHandleClass(!iconHandle)}` }),

    children
    ));

};

const DraggableItem = withDnD(DraggableItemComponent);

export { DraggableItem, hoverSortable };